var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('Titulo',{attrs:{"titulo":'Novo pedido de venda'}})],1)],1),_c('v-row',[_c('v-col',[_c('v-card',{class:(_vm.isMobile ? 'py-4' : 'pa-6') + ' rounded-xl',attrs:{"outlined":""}},[_c('FormPedidoVenda',{on:{"on-submit":_vm.grava}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }